// extracted by mini-css-extract-plugin
export default {"miniCard":"MiniCard_miniCard__rpq0R","header":"MiniCard_header__IWKl6","description":"MiniCard_description__X-dtw","tags":"MiniCard_tags__HcdBm"};